// Hours a vet can wait before the pet-family Klaviyo email goes out.
// 0 means send as soon as the case is submitted.
export const FAMILY_EMAIL_DELAYS = [
  { hours: 0, label: "Send now" },
  { hours: 6, label: "In 6 hours" },
  { hours: 12, label: "In 12 hours" },
  { hours: 24, label: "In 24 hours" },
];

export function familyEmailSendAt(hours, now = new Date()) {
  return new Date(now.getTime() + hours * 60 * 60 * 1000);
}

/**
 * Clock time the family email will send, in the vet's local timezone.
 * Same-day times are just the clock; later times say when.
 */
export function formatFamilyEmailWhen(hours, now = new Date()) {
  if (!hours) return "upon submission";

  const sendAt = familyEmailSendAt(hours, now);
  const time = sendAt.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
  });

  if (sendAt.toDateString() === now.toDateString()) return time;

  const tomorrow = new Date(now);
  tomorrow.setDate(now.getDate() + 1);
  if (sendAt.toDateString() === tomorrow.toDateString()) {
    return `${time} tomorrow`;
  }

  const day = sendAt.toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
  });
  return `${time} ${day}`;
}
